import React from 'react';
import { Typography } from '../typography/typography';

type Props = {
  children: React.ReactNode;
};

export const SectionHeaderTitle: React.FC<Props> = ({ children }) => {
  return <Typography variant="headline-2">{children}</Typography>;
};
